export function authHeader() {
    // return authorization header with jwt token
    let token = sessionStorage.getItem("token");
    if (token) {
        return { 
            'Authorization': 'Bearer ' + token,
         };
    } else {
        return {};
    }
}

export function authHeaderRefreshToken() {
    // return authorization header with jwt token
    let token = sessionStorage.getItem("refreshToken");
    if (token) {
        return { 
            'Authorization': 'Bearer ' + token,
         };
    } else {
        return {};
    }
}